import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const closeModals = () => {
    setIsPrivacyOpen(false);
    setIsTermsOpen(false);
  };
  return <footer className="bg-[#050810] text-dark-gray text-center py-10 px-4 border-t border-white/5 relative" data-id="element-197">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-6" data-id="element-198">
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-medium" data-id="element-199">
          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-primary transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-200">
            Política de Privacidad
          </button>
          <span className="text-white/20 hidden sm:inline" data-id="element-201">|</span>
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-primary transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-202">
            Términos y Condiciones
          </button>
        </div>

        {/* Copyright */}
        <div className="space-y-2 text-xs sm:text-sm" data-id="element-203">
          <p className="text-white/80 font-medium" data-id="element-204">
            © 2025 - Domina los Comandos Eléctricos | Todos los derechos
            reservados
          </p>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      {isPrivacyOpen && <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={closeModals} data-id="element-205">
          <div className="bg-[#111827] border border-white/10 rounded-xl w-full max-w-lg max-h-[80vh] flex flex-col shadow-2xl animate-cascade-fade-delay-1" style={{
        animation: 'none'
      }} // Override global animation for modal pop
      onClick={e => e.stopPropagation()} data-id="element-206">
            {/* Header */}
            <div className="flex justify-between items-center p-5 border-b border-white/10 sticky top-0 bg-[#111827] rounded-t-xl z-10" data-id="element-207">
              <h2 className="text-white font-bold text-xl" data-id="element-208">
                Política de Privacidad
              </h2>
              <button onClick={closeModals} className="text-dark-gray hover:text-white transition-colors p-1 rounded-md hover:bg-white/10" aria-label="Cerrar" data-id="element-209">
                <XIcon className="w-6 h-6" data-id="element-210" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto text-left space-y-5 text-[#D1D5DB] text-sm leading-relaxed" data-id="element-211">
              <p data-id="element-212">
                En <strong data-id="element-213">Domina los Comandos Eléctricos</strong>, respetamos
                tu privacidad y estamos comprometidos con la protección de tus
                datos personales. Esta política explica cómo recopilamos, usamos
                y protegemos tu información.
              </p>

              <div data-id="element-214">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-215">
                  1. Información que recopilamos
                </h3>
                <p data-id="element-216">
                  Al realizar una compra, recopilamos tu nombre, dirección de
                  correo electrónico y datos de facturación. Los detalles de
                  pago son procesados de forma segura por pasarelas de pago de
                  terceros (como Hotmart, Stripe o PayPal) y no almacenamos los
                  datos de tu tarjeta de crédito.
                </p>
              </div>

              <div data-id="element-217">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-218">
                  2. Uso de la información
                </h3>
                <p data-id="element-219">Utilizamos tu información para:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-220">
                  <li data-id="element-221">Procesar tu compra y entregar el producto digital.</li>
                  <li data-id="element-222">
                    Enviarte actualizaciones, bonos y material relacionado con
                    el curso.
                  </li>
                  <li data-id="element-223">
                    Proporcionar soporte al cliente y responder a tus consultas.
                  </li>
                </ul>
              </div>

              <div data-id="element-224">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-225">
                  3. Protección de datos
                </h3>
                <p data-id="element-226">
                  Implementamos medidas de seguridad estándar de la industria
                  para proteger tu información personal contra acceso no
                  autorizado, alteración o destrucción. No vendemos, alquilamos
                  ni compartimos tus datos con terceros no afiliados con fines
                  de marketing.
                </p>
              </div>

              <div data-id="element-227">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-228">
                  4. Cookies
                </h3>
                <p data-id="element-229">
                  Nuestro sitio web utiliza cookies esenciales para garantizar
                  el correcto funcionamiento de la plataforma y cookies
                  analíticas para entender cómo interactúas con nuestro sitio,
                  lo que nos ayuda a mejorar la experiencia del usuario.
                </p>
              </div>

              <div data-id="element-230">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-231">
                  5. Derechos del usuario
                </h3>
                <p data-id="element-232">
                  Tienes derecho a solicitar el acceso, rectificación o
                  eliminación de tus datos personales en cualquier momento. Si
                  deseas dejar de recibir nuestros correos, puedes usar el
                  enlace de cancelación de suscripción incluido en cada mensaje.
                </p>
              </div>
            </div>
          </div>
        </div>}

      {/* Terms & Conditions Modal */}
      {isTermsOpen && <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={closeModals} data-id="element-233">
          <div className="bg-[#111827] border border-white/10 rounded-xl w-full max-w-lg max-h-[80vh] flex flex-col shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-234">
            {/* Header */}
            <div className="flex justify-between items-center p-5 border-b border-white/10 sticky top-0 bg-[#111827] rounded-t-xl z-10" data-id="element-235">
              <h2 className="text-white font-bold text-xl" data-id="element-236">
                Términos y Condiciones
              </h2>
              <button onClick={closeModals} className="text-dark-gray hover:text-white transition-colors p-1 rounded-md hover:bg-white/10" aria-label="Cerrar" data-id="element-237">
                <XIcon className="w-6 h-6" data-id="element-238" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto text-left space-y-5 text-[#D1D5DB] text-sm leading-relaxed" data-id="element-239">
              <p data-id="element-240">
                Al acceder y realizar una compra en{' '}
                <strong data-id="element-241">Domina los Comandos Eléctricos</strong>, aceptas los
                siguientes términos y condiciones. Por favor, léelos
                cuidadosamente.
              </p>

              <div data-id="element-242">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-243">
                  1. Aceptación
                </h3>
                <p data-id="element-244">
                  El uso de este sitio web y la adquisición de nuestros
                  productos digitales implica la aceptación total y sin reservas
                  de estos términos y condiciones.
                </p>
              </div>

              <div data-id="element-245">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-246">
                  2. Producto digital
                </h3>
                <p data-id="element-247">
                  "Domina los Comandos Eléctricos" es un producto 100% digital
                  (eBook/Guía en PDF y recursos adicionales). Tras la
                  confirmación del pago, recibirás acceso inmediato o un enlace
                  de descarga en tu correo electrónico. No se enviará ningún
                  artículo físico a tu domicilio.
                </p>
              </div>

              <div data-id="element-248">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-249">
                  3. Política de reembolso
                </h3>
                <p data-id="element-250">
                  Ofrecemos una garantía de satisfacción de 7 días. Si el
                  producto no cumple con tus expectativas, puedes solicitar un
                  reembolso completo dentro de los primeros 7 días posteriores a
                  la compra. Pasado este período, no se emitirán reembolsos bajo
                  ninguna circunstancia.
                </p>
              </div>

              <div data-id="element-251">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-252">
                  4. Propiedad intelectual
                </h3>
                <p data-id="element-253">
                  Todo el contenido, textos, diagramas, imágenes y materiales
                  incluidos en el producto están protegidos por derechos de
                  autor. Tu compra te otorga una licencia de uso personal e
                  intransferible. Queda estrictamente prohibida la reproducción,
                  distribución, modificación o reventa del material sin nuestra
                  autorización expresa por escrito.
                </p>
              </div>

              <div data-id="element-254">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-255">
                  5. Limitación de responsabilidad
                </h3>
                <p data-id="element-256">
                  El contenido de esta guía tiene fines estrictamente educativos
                  e informativos. El autor no se hace responsable por daños,
                  accidentes, lesiones o pérdidas materiales derivadas de la
                  mala aplicación de los conceptos enseñados. El trabajo con
                  electricidad es peligroso; siempre debes utilizar equipo de
                  protección y cumplir con las normativas eléctricas de tu país.
                </p>
              </div>

              <div data-id="element-257">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-258">
                  6. Descargo de responsabilidad del producto
                </h3>
                <p data-id="element-259">
                  Este es un producto digital. No se enviará ningún producto
                  físico. El contenido de este programa tiene fines educativos.
                  Trabajar con electricidad conlleva riesgos; siempre respeta
                  las normativas de seguridad locales.
                </p>
              </div>
            </div>
          </div>
        </div>}
    </footer>;
}